export const RESET_RESERVATION_TYPE_ISFETCHING =
  'RESET_RESERVATION_TYPE_ISFETCHING';
export const GET_RESERVATION_TYPE_REQUEST = 'GET_RESERVATION_TYPE_REQUEST';
export const GET_RESERVATION_TYPE_SUCCESS = 'GET_RESERVATION_TYPE_SUCCESS';
export const LIST_RESERVATION_TYPES_REQUEST = 'LIST_RESERVATION_TYPES_REQUEST';
export const RESERVATION_TYPE_LIST_REQUESTING =
  'RESERVATION_TYPE_LIST_REQUESTING';
export const LIST_RESERVATION_TYPES_SUCCESS = 'LIST_RESERVATION_TYPES_SUCCESS';
